/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { showConsent } from "./CookiePopupSlice";
import { useTranslation, Trans } from "react-i18next"

import "./CookiePopup.scss";

function getAgreeDate() {
  const d = new Date();
  const year = d.getFullYear();
  const month = d.getMonth() + 12;
  const day = d.getDate();
  return new Date(year, month, day);
}

export function setConsent(isAgree) {
  const expireDate = isAgree ? getAgreeDate() : null;

  Cookies.set("CONSENT", isAgree ? "YES" : "NO", {
    path: "/",
    expires: expireDate,
  });
}

export default function CookiePopup() {
  const dispatch = useDispatch();
  const cookies = Cookies.get();
  const cookieModal = useRef();
  const [isEnabled, setIsEnabled] = useState(true);

  const { isVisible } = useSelector((state) => state.cookiePopup);

  const { t } = useTranslation();

  useEffect(() => {
    if (cookies["CONSENT"] === undefined) {
      window.jQuery("body").addClass("body--consent");
      dispatch(showConsent());
    } else {
      setIsEnabled(false);
    }
  }, []);

  async function handleClick(isAgree) {
    setConsent(isAgree);
    setIsEnabled(false);
    window.jQuery(".body--consent").removeClass("body--consent");
    if (isAgree) {
      try {
        window.gtag('consent', 'update', { 'ad_storage': 'granted' });
      } catch (error) {
        console.error(error);
      }
    }
  }

  if (!isEnabled) {
    return <React.Fragment />;
  }

  return (
    <div
      id="cookieModal"
      ref={cookieModal}
      className={isVisible ? "" : "d-none"}
    >
      <div className="cookie_popup__dialog">
        <div className="cookie_popup__content p-2 row no-gutters">
          <div className="cookie_popup__body mr-sm-3 col">
            {t('cookie_consent_description')}
            {" "}
            <Trans i18nKey="more_info_cookie_link">
              See our <a href="/privacy-policy" className="cookie_popup__link">Cookie Policy</a> for more information.
            </Trans>
          </div>
          <div className="col-12 col-sm-auto text-center">
            <button
              type="button"
              className="btn btn-primary px-3 mt-2"
              data-dismiss="modal"
              onClick={() => handleClick(true)}
            >
              {t('agree_all_cookies')}
            </button>
            <button
              type="button"
              className="btn btn-outline-primary px-4 ml-2 mt-2"
              data-dismiss="modal"
              onClick={() => handleClick(false)}
            >
              {t('necessary_cookies')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
